import { Bot, BookOpen, Brain, Calculator, CalendarDays, Castle, ChartNoAxesColumnIncreasing, CircleHelp, Code2, FlaskConical, Gamepad2, Globe2, History, House, Landmark, Languages, Layers3, Leaf, Library, LogOut, MonitorCog, Music2, Play, School, Settings, ShieldCheck, Sparkles, UserPlus, Users, Waypoints, Zap, type LucideIcon } from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
  home: House, quiz: CircleHelp, play: Play, library: Library, chart: ChartNoAxesColumnIncreasing,
  history: History, book: BookOpen, school: School, calendar: CalendarDays, brain: Brain,
  game: Gamepad2, language: Languages, calculator: Calculator, globe: Globe2, flask: FlaskConical,
  zap: Zap, music: Music2, code: Code2, leaf: Leaf, sparkles: Sparkles, admin: ShieldCheck,
  stack: Layers3, bot: Bot, monitor: MonitorCog, users: Users, "user-plus": UserPlus,
  settings: Settings, logout: LogOut, timeline: Waypoints, landmark: Landmark, castle: Castle
};

export function Icon({ name, size = 18 }: { name: string; size?: number }) {
  const Component = iconMap[name] ?? BookOpen;
  return <Component size={size} strokeWidth={1.9} />;
}
